export enum LinkedCollectionType {
	None = 0,
	SingleRecord = 1,
	GridRecord = 2
}